import { render, staticRenderFns } from "./TestsDone.vue?vue&type=template&id=13b2e58c"
import script from "./TestsDone.vue?vue&type=script&lang=js"
export * from "./TestsDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports